import { z } from "zod";

export const platformSettingsSchema = z.object({
  consoleName: z.string().trim().min(1).max(64),
  defaultPeriod: z.enum(["week", "month", "quarter"]),
  operationsTarget: z.number().min(0).max(100),
}).strict();
export const defaultPlatformSettings = { consoleName: "Yahshi 控制台", defaultPeriod: "week", operationsTarget: 60 } as const;
export const settingsSnapshotSchema = z.object({
  environment: z.enum(["production", "development"]), version: z.number().int().nonnegative(),
  settings: platformSettingsSchema, updatedAt: z.string().nullable(), updatedBy: z.string().nullable(),
});
export const platformSettingsUpdateSchema = z.object({
  settings: platformSettingsSchema.partial().refine((value) => Object.keys(value).length > 0, "请至少修改一项设置"),
  expectedVersion: z.number().int().nonnegative(),
}).strict();
export const settingsAuditQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  offset: z.coerce.number().int().min(0).max(2147483647).default(0),
}).strict();
export const auditPageSchema = z.object({
  items: z.array(z.object({
    id: z.string(), actorId: z.string(), action: z.string(), target: z.string().nullable(),
    requestId: z.string().nullable(), createdAt: z.string(), metadata: z.record(z.string(), z.unknown()),
  })), total: z.number().int().nonnegative(),
});
export type PlatformSettings = z.infer<typeof platformSettingsSchema>;
export type SettingsSnapshot = z.infer<typeof settingsSnapshotSchema>;
export type SettingsAuditPage = z.infer<typeof auditPageSchema>;
